<template>
  <div
      class="home page-template-default page page-id-12105 wp-custom-logo header-horizontal site-layout-full elementor-default elementor-kit-12104 elementor-page elementor-page-12105">
    <div class="whole-layout">

      <div class="page-background to-move"></div>
      <footer id="footer" class="to-move full centered footer-separator" itemtype="https://schema.org/WPFooter"
              itemscope="">
        <div class="foot-widgets five-col dark-sidebar">
          <div class="foot-content clearfix">
            <div id="custom_html-3" class="widget_text widget widget_custom_html">
              <h3 class="title"><span>关注我们/FOLLOW</span></h3>
              <div class="textwidget custom-html-widget">
                <div class="content-text">
                  <br>
                  官方微信公众号
                </div>
                <br>
                <a id="follow-weixxinvideo">官方微信视频号</a><br>
                <a id="follow-weibo">官方微博</a><br>
              </div>
            </div>
            <div id="contact-info-3" class="widget widget_contact_info">
              <h3 class="title"><span>联系我们/CONTACT</span></h3>
              <div class="info">
                <div class="content-text">广州总部：020-29121923<br>
                  广州市白云区齐心路68号中国南方航空大厦4楼<br>
                </div>
              </div>
            </div>
            <div id="contact-info-4" class="widget widget_contact_info">
              <h3 class="title"><span>咨询了解/CONSULTATIVE</span></h3>
              <div class="info">
                <div class="content-text">渠道加盟<br>
                  Email：contact@skycos.com.cn<br>
                  <br>
                  业务咨询 <br>
                  Email：service@skycos.com.cn<br>
                  <br>
                </div>
              </div>
            </div>
            <div id="text-18" class="widget widget_text">
              <h3 class="title"><span>帮助中心/help</span></h3>
              <div class="textwidget">
                <p><a
                    title="《用户注册与服务协议》《隐私政策》变更公告-20220312"
                    target="_blank"
                    rel="noopener">最新公告</a></p>
              </div>
            </div>
            <div id="text-18" class="widget widget_text">
              <h3 class="title"><span>家族网站/enter</span></h3>
              <div class="footer-item-box" @click="skip('https://www.aromore.com.cn/')">
                <img class="footer-item-p1" alt="小茉护肤" src="@/assets/images/pic-art.png">
              </div>
              <div class="footer-item-box" @click="skip('https://www.douhuu.com.cn/')">
                <img class="footer-item-p2" alt="豆乎" src="@/assets/images/partner-2.png">
              </div>
            </div>
          </div>
        </div>
        <div class="foot-items">
          <div class="foot-content clearfix">
            <div class="foot-text">
              广州天妍化妆品有限公司 &nbsp; &nbsp;
              <p style="text-align:center">&copy; 2023-2025
               <a
                    target="_blank" href="https://beian.miit.gov.cn/">粤ICP备2024168453号-4</a>
              </p><br>
            </div>
          </div>
        </div>
      </footer>
      <a id="to-top" class="to-top fa fa-angle-up"></a>
      <div id="content-overlay" class="to-move"></div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      scrolltop: 0,

      // 点击显示弹出框
      isCodePopShow: false,
      // 点击弹出下拉框
      isDropShow: false
    }
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    handleWheel(event) {
      // 阻止默认行为（可选，根据需要）
      // event.preventDefault();
      // 获取滚动到顶部的距离
      this.scrolltop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    },
    pathTo(url) {
      this.$router.push({
        path: url
      })
    },
    skip(url) {
      window.open(url);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/static/css/style.min.css";
@import "@/assets/static/css/elementor-icons.min.css";
@import "@/assets/static/css/custom-frontend.min.css";
@import "@/assets/static/css/post-12104.css";
@import "@/assets/static/css/global.css";
@import "@/assets/static/css/post-12105.css";
@import "@/assets/static/css/lightgallery.min.css";
@import "@/assets/static/css/font-awesome.min.css";
@import "@/assets/static/css/icomoon.css";
@import "@/assets/static/css/style.css";
@import "@/assets/static/css/user.css";
@import "@/assets/static/css/all.min.css";
@import "@/assets/static/css/v4-shims.min.css";
@import "@/assets/static/css/css-Raleway.css";

a {
  cursor: pointer;
}

.submenu-show {
  display: block;
}

.pic-box {
  width: 200px;

  .pic-img {
    width: 100%;
  }
}

.map-img {

}

.sub-menu-img {
  width: 140px;
}

.btn-bottom-green {
  background: white;
  border-radius: 6px;
  border: 1px solid #035940;
  color: #035940;
  font-size: 18px;
  padding: 10px 30px;
  width: fit-content;
  margin: 0 0 100px;
  cursor: pointer;
  position: relative;
  left: 70%;
}

.btn-bottom-deep {
  background: #035940;
  border-radius: 6px;
  border: 1px solid #035940;
  color: #fff;
  font-size: 18px;
  padding: 10px 30px;
  width: fit-content;
  margin: 0 0 100px;
  cursor: pointer;
  position: relative;
  left: 70%;
}

/*! This file is auto-generated */
.wp-block-button__link {
  color: #fff;
  background-color: #32373c;
  border-radius: 9999px;
  box-shadow: none;
  text-decoration: none;
  padding: calc(.667em + 2px) calc(1.333em + 2px);
  font-size: 1.125em
}

.wp-block-file__button {
  background: #32373c;
  color: #fff;
  text-decoration: none
}

body {
  --wp--preset--color--black: #000000;
  --wp--preset--color--cyan-bluish-gray: #abb8c3;
  --wp--preset--color--white: #ffffff;
  --wp--preset--color--pale-pink: #f78da7;
  --wp--preset--color--vivid-red: #cf2e2e;
  --wp--preset--color--luminous-vivid-orange: #ff6900;
  --wp--preset--color--luminous-vivid-amber: #fcb900;
  --wp--preset--color--light-green-cyan: #7bdcb5;
  --wp--preset--color--vivid-green-cyan: #00d084;
  --wp--preset--color--pale-cyan-blue: #8ed1fc;
  --wp--preset--color--vivid-cyan-blue: #0693e3;
  --wp--preset--color--vivid-purple: #9b51e0;
  --wp--preset--gradient--vivid-cyan-blue-to-vivid-purple: linear-gradient(135deg, rgba(6, 147, 227, 1) 0%, rgb(155, 81, 224) 100%);
  --wp--preset--gradient--light-green-cyan-to-vivid-green-cyan: linear-gradient(135deg, rgb(122, 220, 180) 0%, rgb(0, 208, 130) 100%);
  --wp--preset--gradient--luminous-vivid-amber-to-luminous-vivid-orange: linear-gradient(135deg, rgba(252, 185, 0, 1) 0%, rgba(255, 105, 0, 1) 100%);
  --wp--preset--gradient--luminous-vivid-orange-to-vivid-red: linear-gradient(135deg, rgba(255, 105, 0, 1) 0%, rgb(207, 46, 46) 100%);
  --wp--preset--gradient--very-light-gray-to-cyan-bluish-gray: linear-gradient(135deg, rgb(238, 238, 238) 0%, rgb(169, 184, 195) 100%);
  --wp--preset--gradient--cool-to-warm-spectrum: linear-gradient(135deg, rgb(74, 234, 220) 0%, rgb(151, 120, 209) 20%, rgb(207, 42, 186) 40%, rgb(238, 44, 130) 60%, rgb(251, 105, 98) 80%, rgb(254, 248, 76) 100%);
  --wp--preset--gradient--blush-light-purple: linear-gradient(135deg, rgb(255, 206, 236) 0%, rgb(152, 150, 240) 100%);
  --wp--preset--gradient--blush-bordeaux: linear-gradient(135deg, rgb(254, 205, 165) 0%, rgb(254, 45, 45) 50%, rgb(107, 0, 62) 100%);
  --wp--preset--gradient--luminous-dusk: linear-gradient(135deg, rgb(255, 203, 112) 0%, rgb(199, 81, 192) 50%, rgb(65, 88, 208) 100%);
  --wp--preset--gradient--pale-ocean: linear-gradient(135deg, rgb(255, 245, 203) 0%, rgb(182, 227, 212) 50%, rgb(51, 167, 181) 100%);
  --wp--preset--gradient--electric-grass: linear-gradient(135deg, rgb(202, 248, 128) 0%, rgb(113, 206, 126) 100%);
  --wp--preset--gradient--midnight: linear-gradient(135deg, rgb(2, 3, 129) 0%, rgb(40, 116, 252) 100%);
  --wp--preset--font-size--small: 13px;
  --wp--preset--font-size--medium: 20px;
  --wp--preset--font-size--large: 36px;
  --wp--preset--font-size--x-large: 42px;
  --wp--preset--spacing--20: 0.44rem;
  --wp--preset--spacing--30: 0.67rem;
  --wp--preset--spacing--40: 1rem;
  --wp--preset--spacing--50: 1.5rem;
  --wp--preset--spacing--60: 2.25rem;
  --wp--preset--spacing--70: 3.38rem;
  --wp--preset--spacing--80: 5.06rem;
  --wp--preset--shadow--natural: 6px 6px 9px rgba(0, 0, 0, 0.2);
  --wp--preset--shadow--deep: 12px 12px 50px rgba(0, 0, 0, 0.4);
  --wp--preset--shadow--sharp: 6px 6px 0px rgba(0, 0, 0, 0.2);
  --wp--preset--shadow--outlined: 6px 6px 0px -3px rgba(255, 255, 255, 1), 6px 6px rgba(0, 0, 0, 1);
  --wp--preset--shadow--crisp: 6px 6px 0px rgba(0, 0, 0, 1);
}

:where(.is-layout-flex) {
  gap: 0.5em;
}

:where(.is-layout-grid) {
  gap: 0.5em;
}

body .is-layout-flex {
  display: flex;
}

body .is-layout-flex {
  flex-wrap: wrap;
  align-items: center;
}

body .is-layout-flex > * {
  margin: 0;
}

body .is-layout-grid {
  display: grid;
}

body .is-layout-grid > * {
  margin: 0;
}

:where(.wp-block-columns.is-layout-flex) {
  gap: 2em;
}

:where(.wp-block-columns.is-layout-grid) {
  gap: 2em;
}

:where(.wp-block-post-template.is-layout-flex) {
  gap: 1.25em;
}

:where(.wp-block-post-template.is-layout-grid) {
  gap: 1.25em;
}

.has-black-color {
  color: var(--wp--preset--color--black) !important;
}

.has-cyan-bluish-gray-color {
  color: var(--wp--preset--color--cyan-bluish-gray) !important;
}

.has-white-color {
  color: var(--wp--preset--color--white) !important;
}

.has-pale-pink-color {
  color: var(--wp--preset--color--pale-pink) !important;
}

.has-vivid-red-color {
  color: var(--wp--preset--color--vivid-red) !important;
}

.has-luminous-vivid-orange-color {
  color: var(--wp--preset--color--luminous-vivid-orange) !important;
}

.has-luminous-vivid-amber-color {
  color: var(--wp--preset--color--luminous-vivid-amber) !important;
}

.has-light-green-cyan-color {
  color: var(--wp--preset--color--light-green-cyan) !important;
}

.has-vivid-green-cyan-color {
  color: var(--wp--preset--color--vivid-green-cyan) !important;
}

.has-pale-cyan-blue-color {
  color: var(--wp--preset--color--pale-cyan-blue) !important;
}

.has-vivid-cyan-blue-color {
  color: var(--wp--preset--color--vivid-cyan-blue) !important;
}

.has-vivid-purple-color {
  color: var(--wp--preset--color--vivid-purple) !important;
}

.has-black-background-color {
  background-color: var(--wp--preset--color--black) !important;
}

.has-cyan-bluish-gray-background-color {
  background-color: var(--wp--preset--color--cyan-bluish-gray) !important;
}

.has-white-background-color {
  background-color: var(--wp--preset--color--white) !important;
}

.has-pale-pink-background-color {
  background-color: var(--wp--preset--color--pale-pink) !important;
}

.has-vivid-red-background-color {
  background-color: var(--wp--preset--color--vivid-red) !important;
}

.has-luminous-vivid-orange-background-color {
  background-color: var(--wp--preset--color--luminous-vivid-orange) !important;
}

.has-luminous-vivid-amber-background-color {
  background-color: var(--wp--preset--color--luminous-vivid-amber) !important;
}

.has-light-green-cyan-background-color {
  background-color: var(--wp--preset--color--light-green-cyan) !important;
}

.has-vivid-green-cyan-background-color {
  background-color: var(--wp--preset--color--vivid-green-cyan) !important;
}

.has-pale-cyan-blue-background-color {
  background-color: var(--wp--preset--color--pale-cyan-blue) !important;
}

.has-vivid-cyan-blue-background-color {
  background-color: var(--wp--preset--color--vivid-cyan-blue) !important;
}

.has-vivid-purple-background-color {
  background-color: var(--wp--preset--color--vivid-purple) !important;
}

.has-black-border-color {
  border-color: var(--wp--preset--color--black) !important;
}

.has-cyan-bluish-gray-border-color {
  border-color: var(--wp--preset--color--cyan-bluish-gray) !important;
}

.has-white-border-color {
  border-color: var(--wp--preset--color--white) !important;
}

.has-pale-pink-border-color {
  border-color: var(--wp--preset--color--pale-pink) !important;
}

.has-vivid-red-border-color {
  border-color: var(--wp--preset--color--vivid-red) !important;
}

.has-luminous-vivid-orange-border-color {
  border-color: var(--wp--preset--color--luminous-vivid-orange) !important;
}

.has-luminous-vivid-amber-border-color {
  border-color: var(--wp--preset--color--luminous-vivid-amber) !important;
}

.has-light-green-cyan-border-color {
  border-color: var(--wp--preset--color--light-green-cyan) !important;
}

.has-vivid-green-cyan-border-color {
  border-color: var(--wp--preset--color--vivid-green-cyan) !important;
}

.has-pale-cyan-blue-border-color {
  border-color: var(--wp--preset--color--pale-cyan-blue) !important;
}

.has-vivid-cyan-blue-border-color {
  border-color: var(--wp--preset--color--vivid-cyan-blue) !important;
}

.has-vivid-purple-border-color {
  border-color: var(--wp--preset--color--vivid-purple) !important;
}

.has-vivid-cyan-blue-to-vivid-purple-gradient-background {
  background: var(--wp--preset--gradient--vivid-cyan-blue-to-vivid-purple) !important;
}

.has-light-green-cyan-to-vivid-green-cyan-gradient-background {
  background: var(--wp--preset--gradient--light-green-cyan-to-vivid-green-cyan) !important;
}

.has-luminous-vivid-amber-to-luminous-vivid-orange-gradient-background {
  background: var(--wp--preset--gradient--luminous-vivid-amber-to-luminous-vivid-orange) !important;
}

.has-luminous-vivid-orange-to-vivid-red-gradient-background {
  background: var(--wp--preset--gradient--luminous-vivid-orange-to-vivid-red) !important;
}

.has-very-light-gray-to-cyan-bluish-gray-gradient-background {
  background: var(--wp--preset--gradient--very-light-gray-to-cyan-bluish-gray) !important;
}

.has-cool-to-warm-spectrum-gradient-background {
  background: var(--wp--preset--gradient--cool-to-warm-spectrum) !important;
}

.has-blush-light-purple-gradient-background {
  background: var(--wp--preset--gradient--blush-light-purple) !important;
}

.has-blush-bordeaux-gradient-background {
  background: var(--wp--preset--gradient--blush-bordeaux) !important;
}

.has-luminous-dusk-gradient-background {
  background: var(--wp--preset--gradient--luminous-dusk) !important;
}

.has-pale-ocean-gradient-background {
  background: var(--wp--preset--gradient--pale-ocean) !important;
}

.has-electric-grass-gradient-background {
  background: var(--wp--preset--gradient--electric-grass) !important;
}

.has-midnight-gradient-background {
  background: var(--wp--preset--gradient--midnight) !important;
}

.has-small-font-size {
  font-size: var(--wp--preset--font-size--small) !important;
}

.has-medium-font-size {
  font-size: var(--wp--preset--font-size--medium) !important;
}

.has-large-font-size {
  font-size: var(--wp--preset--font-size--large) !important;
}

.has-x-large-font-size {
  font-size: var(--wp--preset--font-size--x-large) !important;
}

.wp-block-navigation a:where(:not(.wp-element-button)) {
  color: inherit;
}

:where(.wp-block-post-template.is-layout-flex) {
  gap: 1.25em;
}

:where(.wp-block-post-template.is-layout-grid) {
  gap: 1.25em;
}

:where(.wp-block-columns.is-layout-flex) {
  gap: 2em;
}

:where(.wp-block-columns.is-layout-grid) {
  gap: 2em;
}

.wp-block-pullquote {
  font-size: 1.5em;
  line-height: 1.6;
}

#footer {
  background-color: #e6f2e6;
}
.foot-items {
  background-color: #e6f2e6;
}

/*脚部调整*/
#footer.centered {
  text-align: left;
}

#footer.centered, #footer.centered .widget h3.title, #footer.centered .widget .socials {
  text-align: left;
}

.foot-items, #footer .foot-widgets {
  padding-left: 200px;
}

@media screen and (max-width: 480px) {
  .widget {
    text-align: left;
  }
  .foot-items, #footer .foot-widgets {
    padding-left: 20px;
  }
}

.foot-img {
  display: flex;
  justify-content: center;
}

#footer .widget {
  font-size: 15px;
}

/*横杠*/
.elementor-divider-separator {
  border-radius: 8px;
}

/*分类归档名称调整*/
.posts-list .title-bar.outside .page-title {
  font-size: 0;
  padding-top: 30px;
}

.posts-list .title-bar.outside .page-title span {
  font-size: 48px;
}

/*菜单间距*/
.header-horizontal .top-menu > li > a {
  padding: 0 16px;
}

/*新闻动态*/
h2.post-title {
  font-size: 1em;
  line-height: 1.4em;
}

.item-image a::before {
  background-color: #0000008c;
}

.item-image a::after {
  font-size: 0;
}

@media only screen and (max-width: 768px) {
  .bricks-frame .formatter {
    padding-left: 0;
  }
}

.bricks-frame .formatter, .post_theme_options .formatter {
  padding-top: 20px;
}

/*规则菜单*/
.widget_nav_menu ul ul {
  margin: 0 0 0 16px;
}

/*页脚按钮*/
.footer-item-box {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-top: 30px;
  cursor: pointer;

  .footer-item-p1 {
    height: 60px;
  }
  .footer-item-p2 {
    height: 30px;
  }
}

</style>
